const PERSIAN_ZERO = 0x06F0;
const ARABIC_ZERO = 0x0660;

export const persianToEnglishDigits = (input: string): string =>
  input.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, (char) => {
    const code = char.charCodeAt(0);

    if (code >= PERSIAN_ZERO && code <= PERSIAN_ZERO + 9) {
      return String(code - PERSIAN_ZERO);
    }

    return String(code - ARABIC_ZERO);
  });